import type { AlertOptions } from '@flash-global66/g-dialog-alert';

export const OFFSHORE_CARD_CONFIG = {
  BRAND_MASTERCARD: 0,
  TYPE_PRODUCT_VIRTUAL: 1,
  COUNTRY_CODE: 'CO',
  DOCUMENT_TYPE: 'PASS',
  INITIAL_STEP: 1,
} as const;

export const OFFSHORE_COUNTRY_CODE = 'OF' as const;

export const CARD_COUNTRIES = {
  CHILE: 'CL',
  COLOMBIA: 'CO',
} as const;

export const CARD_PARTNERS = {
  POMELO: 'pomelo',
} as const;

export const CARD_CURRENCIES = {
  USD: 'USD',
} as const;

export const STANDARD_CARD_COUNTRIES: string[] = [
  CARD_COUNTRIES.CHILE,
  CARD_COUNTRIES.COLOMBIA,
] as const;

export const CARD_TARIFF_URLS = {
  CO: 'https://bases.global66.com/wp-content/uploads/2024/09/Tarifario-Global66-SEDPE-B2B-10-09.pdf',
  CL: 'https://bases.global66.com/wp-content/uploads/2024/07/Tarifario-Global-Card-S.A-26-07.pdf',
} as const;

export const CARD_STATUS = {
  // ACTIVAS
  COMPLETED: 'COMPLETED',
  ACTIVE: 'ACTIVE',
  // BLOQUEADAS
  BLOCKED: 'BLOCKED',
  INACTIVE: 'INACTIVE',
  FRAUD_BLOCK: 'FRAUD_BLOCK',
  BIN_ATTACK_FRAUD: 'BIN_ATTACK_FRAUD',
  EMERGENCY_BLOCK: 'EMERGENCY_BLOCK',
  // BORRADA
  DELETED: 'DELETED',
  // EXPIRADA (Tarjetas Desechables)
  CLOSED: 'CLOSED',
  // EN PROCESO
  IN_PROCESS: 'IN_PROCESS',
  // ERROR
  FAILED_CREATION: 'FAILED_CREATION',
};

export const OFFSHORE_NOT_ISSUED_STATUSES = [
  CARD_STATUS.IN_PROCESS,
  CARD_STATUS.FAILED_CREATION,
];

export const CARD_TYPE_PRODUCT = {
  VIRTUAL: 'VIRTUAL',
  PHYSICAL: 'PHYSICAL',
} as const;

export const SALES_EXECUTIVE_CONTACT_MESSAGE =
  'Contáctate con tu ejecutivo de venta para conocer el motivo.';

export const RETRY_CREATION_TOOLTIP_MESSAGE =
  'Por favor, reintenta la creación de la Smart Card desde las acciones de esta tarjeta.';

export const DELETE_RESTRICTED_CARD_ALERT: AlertOptions = {
  type: 'warning',
  title: 'No podemos eliminar esta tarjeta',
  description: 'Contacta a tu ejecutivo de cuenta',
  primaryText: 'Entendido',
};

/** Valor a mostrar cuando el dato consultado no aplica a la tarjeta. */
export const DASHBOARD_EMPTY_CONFIG_VALUE = '-';
